interface BuildTimeConfig {
	env: string
}

const buildTimeConfig: BuildTimeConfig = {
	env: 'production',
}

export default buildTimeConfig;